// extracted by mini-css-extract-plugin
export default {"linksSection":"kJ-z"};